export enum OutlookInsightsEvents {
  Onboarding = 'outlook-onboarding',
  OutlookAuth = 'outlook-auth-service',
  AiAutoPopulate = 'ai-auto-populate',
}
